<!-- <mat-card>
  <mat-card-content>
    <form #form>
      <div id="chargify-form">
        <h3 class="chargify-title">Customer Billing Details</h3>

    
        <div
          *ngIf="usePropertyDetails; else customBillingAddress"
          class="property-details"
        >
          <div class="property-row">
            <div class="property-item">
              <p><strong>First Name:</strong> {{ firstName }}</p>
            </div>
            <div class="property-item">
              <p><strong>Last Name:</strong> {{ lastName }}</p>
            </div>
          </div>

          <div class="property-row">
            <div class="property-item">
              <p><strong>Address:</strong> {{ address }}</p>
            </div>
          </div>

          <div class="property-row">
            <div class="property-item">
              <p><strong>City:</strong> {{ city }}</p>
            </div>
            <div class="property-item">
              <p><strong>State:</strong> {{ state }}</p>
            </div>
            <div class="property-item">
              <p><strong>ZIP Code:</strong> {{ zip }}</p>
            </div>
            <div class="property-item">
              <p><strong>Country:</strong> US</p>
            </div>
          </div>
        </div>
   
        <ng-template #customBillingAddress>
          <div class="form-row">
            <mat-form-field class="small-field">
              <mat-label>First Name</mat-label>
              <input matInput [(ngModel)]="firstName" name="firstName" />
            </mat-form-field>
            <mat-form-field class="small-field">
              <mat-label>Last Name</mat-label>
              <input
                matInput
                [(ngModel)]="lastName"
                name="lastName"
                (input)="clearError('lastName')"
              />
              <mat-error *ngIf="paymentError && !lastName"
                >Last name is required.</mat-error
              >
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field class="full-width">
              <mat-label>Address</mat-label>
              <input
                matInput
                [(ngModel)]="address"
                name="address"
                (input)="onAddressInput($event)"
              />
            </mat-form-field>
            <div
              *ngIf="addressSuggestions.length > 0"
              class="suggestions-container"
            >
              <ul>
                <li class="manual-entry" (click)="enterManualAddress()">
                  <mat-icon class="address-icon">edit</mat-icon>Can't find your address? Type it in
                </li>
                <li
                  *ngFor="let suggestion of addressSuggestions"
                  (click)="selectSuggestion(suggestion)"
                >
                  <mat-icon class="address-icon">location_on</mat-icon>
                  {{ suggestion.address.freeformAddress }}
                </li>
              </ul>
            </div>
          </div>

          <div class="form-row">
            <mat-form-field class="medium-field">
              <mat-label>City</mat-label>
              <input matInput [(ngModel)]="city" name="city" />
            </mat-form-field>
            <mat-form-field class="small-field">
              <mat-label>State</mat-label>
              <input matInput [(ngModel)]="state" name="state" />
            </mat-form-field>
            <mat-form-field class="small-field">
              <mat-label>ZIP Code</mat-label>
              <input matInput [(ngModel)]="zip" name="zip" maxlength="5" />
            </mat-form-field>
            <mat-form-field class="small-field">
              <mat-label>Country</mat-label>
              <input
                matInput
                [(ngModel)]="country"
                name="country"
                value="US"
                readonly
              />
            </mat-form-field>
          </div>
        </ng-template>

  
        <div class="payment-method-toggle">
          <h3 *ngIf="!isAch">Credit Card Details</h3>
          <h3 *ngIf="isAch">ACH/Bank Account Details</h3>
          <mat-slide-toggle
            [(ngModel)]="isAch"
            (change)="togglePaymentMethod()"
            [ngModelOptions]="{ standalone: true }"
            labelPosition="after"
          >
            Change Payment Method
          </mat-slide-toggle>
        </div>

    
        <div class="card-info" *ngIf="!isAch">
          <div id="chargify-number"></div>
          <div id="chargify-month"></div>
          <div id="chargify-year"></div>
          <div id="chargify-cvv"></div>
        </div>

        <div class="payment-fields" *ngIf="isAch">
          <div id="chargify-bank-name"></div>
          <div id="chargify-bank-routing-number"></div>
          <div id="chargify-bank-account-number"></div>
          <div id="chargify-bank-accountholder-type"></div>
          <div class="terms-container">
            <mat-checkbox
              [(ngModel)]="achTermsAccepted"
              [ngModelOptions]="{ standalone: true }"
              (change)="onAchTermsCheckboxChange($event)"
            >
              I agree to the
              <a href="https://zentra.co/saas-terms/" target="_blank"
                >ACH Terms and Services</a
              >.
            </mat-checkbox>
            <div *ngIf="!achTermsAccepted" class="error-message">
              <p>Please agree to the ACH terms and services to proceed.</p>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="paymentError" class="error-message">
        <mat-card class="error-card">
          <mat-card-title>Error</mat-card-title>
          <mat-card-content>
            <p>{{ paymentError }}</p>
          </mat-card-content>
        </mat-card>
      </div>
    </form>
  </mat-card-content>
</mat-card> -->

<mat-card>
  <mat-card-content>
    <form #form>
      <!-- Hidden fields for pre-filled customer information -->
      <div class="host-field">
        <input
          type="hidden"
          class="host-input"
          data-chargify="firstName"
          [value]="firstName"
        />
      </div>
      <div class="host-field">
        <input
          type="hidden"
          class="host-input"
          data-chargify="lastName"
          [value]="lastName"
        />
      </div>
      <div class="host-field">
        <input
          type="hidden"
          class="host-input"
          data-chargify="address"
          [value]="address"
        />
      </div>
      <div class="host-field">
        <input
          type="hidden"
          class="host-input"
          data-chargify="city"
          [value]="city"
        />
      </div>
      <div class="host-field">
        <input
          type="hidden"
          class="host-input"
          data-chargify="state"
          [value]="state"
        />
      </div>
      <div class="host-field">
        <input
          type="hidden"
          class="host-input"
          data-chargify="country"
          [value]="country"
        />
      </div>
      <div class="host-field">
        <input
          type="hidden"
          class="host-input"
          data-chargify="zip"
          [value]="zip"
        />
      </div>

      <!-- Visible form fields for user input -->
      <div id="chargify-form">
        <h3 class="chargify-title">Customer Billing Details</h3>

        <!-- Show property details if the checkbox is checked -->
        <div
          *ngIf="usePropertyDetails; else customBillingAddress"
          class="property-details"
        >
          <div class="property-row">
            <div class="property-item">
              <p><strong>First Name:</strong> {{ firstName }}</p>
            </div>
            <div class="property-item">
              <p><strong>Last Name:</strong> {{ lastName }}</p>
            </div>
          </div>

          <div class="property-row">
            <div class="property-item">
              <p><strong>Address:</strong> {{ address }}</p>
            </div>
          </div>

          <div class="property-row">
            <div class="property-item">
              <p><strong>City:</strong> {{ city }}</p>
            </div>
            <div class="property-item">
              <p><strong>State:</strong> {{ state }}</p>
            </div>
            <div class="property-item">
              <p><strong>ZIP Code:</strong> {{ zip }}</p>
            </div>
            <div class="property-item">
              <p><strong>Country:</strong> US</p>
            </div>
          </div>
        </div>

        <!-- Custom billing address form -->
        <ng-template #customBillingAddress>
          <div class="form-row">
            <mat-form-field class="small-field">
              <mat-label>First Name</mat-label>
              <input
                matInput
                [(ngModel)]="firstName"
                name="firstName"
                maxlength="50"
              />
            </mat-form-field>
            <mat-form-field class="small-field">
              <mat-label>Last Name</mat-label>
              <input
                matInput
                [(ngModel)]="lastName"
                name="lastName"
                (input)="clearError('lastName')"
                maxlength="50"
              />
              <mat-error *ngIf="paymentError && !lastName"
                >Last name is required.</mat-error
              >
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field class="full-width">
              <mat-label>Address</mat-label>
              <input
                matInput
                [(ngModel)]="address"
                name="address"
                (input)="onAddressInput($event)"
              />
            </mat-form-field>
            <div
              *ngIf="addressSuggestions.length > 0"
              class="suggestions-container"
            >
              <ul>
                <li class="manual-entry" (click)="enterManualAddress()">
                  <mat-icon class="address-icon">edit</mat-icon>Can't find your address? Type it in
                </li>
                <li
                  *ngFor="let suggestion of addressSuggestions"
                  (click)="selectSuggestion(suggestion)"
                >
                  <mat-icon class="address-icon">location_on</mat-icon>
                  {{ suggestion.address.freeformAddress }}
                </li>
              </ul>
            </div>
          </div>

          <div class="form-row">
            <mat-form-field class="medium-field">
              <mat-label>City</mat-label>
              <input matInput [(ngModel)]="city" name="city" />
            </mat-form-field>
            <mat-form-field class="small-field">
              <mat-label>State</mat-label>
              <input matInput [(ngModel)]="state" name="state" />
            </mat-form-field>
            <mat-form-field class="small-field">
              <mat-label>ZIP Code</mat-label>
              <input matInput [(ngModel)]="zip" name="zip" maxlength="5" />
            </mat-form-field>
            <mat-form-field class="small-field">
              <mat-label>Country</mat-label>
              <input
                matInput
                [(ngModel)]="country"
                name="country"
                value="US"
                readonly
              />
            </mat-form-field>
          </div>
        </ng-template>

        <!-- Payment method toggle -->
        <div class="payment-method-toggle">
          <h3 *ngIf="!isAch">Credit Card Details</h3>
          <h3 *ngIf="isAch">ACH/Bank Account Details</h3>
          <mat-slide-toggle
            [(ngModel)]="isAch"
            (change)="togglePaymentMethod()"
            [ngModelOptions]="{ standalone: true }"
            labelPosition="after"
          >
            Change Payment Method
          </mat-slide-toggle>
        </div>

        <!-- Credit Card Fields -->
        <div class="card-info" *ngIf="!isAch">
          <div id="chargify-number"></div>
          <div id="chargify-month"></div>
          <div id="chargify-year"></div>
          <div id="chargify-cvv"></div>
        </div>

        <!-- ACH/Bank Account Fields -->
        <div class="payment-fields" *ngIf="isAch">
          <div id="chargify-bank-name"></div>
          <div id="chargify-bank-routing-number"></div>
          <div id="chargify-bank-account-number"></div>
          <div id="chargify-bank-accountholder-type"></div>
          <div class="terms-container">
            <mat-checkbox
              [(ngModel)]="achTermsAccepted"
              [ngModelOptions]="{ standalone: true }"
              (change)="onAchTermsCheckboxChange($event)"
            >
              I agree to the
              <a href="https://zentra.co/saas-terms/" target="_blank"
                >ACH Terms and Services</a
              >.
            </mat-checkbox>
            <div *ngIf="!achTermsAccepted" class="error-message">
              <p style="color: red">
                Please agree to the ACH terms and services to proceed.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Error Message -->
      <div *ngIf="paymentError" class="error-message">
        <mat-card class="error-card">
          <mat-card-title>Error</mat-card-title>
          <mat-card-content>
            <p>{{ paymentError }}</p>
          </mat-card-content>
        </mat-card>
      </div>
    </form>
  </mat-card-content>
</mat-card>
